import { sha256 } from 'js-sha256'

export function triggerFileDownload({ filename, content, contentType, isBlob = false }) {
  let dataHref

  if (isBlob) {
    // Handle binary content (e.g., images, PDFs, etc.)
    const blob = new Blob([content], { type: contentType })
    dataHref = URL.createObjectURL(blob)
  } else {
    // Handle text-based content (plain text, HTML, etc.)
    dataHref = `data:${contentType};charset=utf-8,` + encodeURIComponent(content)
  }

  // Create a temporary anchor element and trigger the download
  const element = document.createElement('a')
  element.setAttribute('href', dataHref)
  element.setAttribute('download', filename)

  document.body.appendChild(element)
  element.click()

  document.body.removeChild(element)

  if (isBlob) {
    URL.revokeObjectURL(dataHref)
  }
}

export async function calculateSHA256ForFile(file) {
  const arrayBuffer = await file.arrayBuffer() // Read the file as an ArrayBuffer
  const hash = sha256(arrayBuffer) // Calculate SHA-256 checksum
  return hash // Return SHA-256 hash
}